import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import shared from '../../pages/00_resumes/SharedCSS.module.css';
import resume from '../../pages/00_resumes/resume/Resume.module.css'
import rlresume from '../../pages/00_resumes/RLresume/RLresume.module.css'

function CircleProgress({ percentage }) {
    const svgRef = useRef();
    const [size, setSize] = useState(87); // Default fallback

    useEffect(() => {
        const computed = getComputedStyle(svgRef.current);
        const cssSize = parseFloat(computed.getPropertyValue('--size'));
        if (!isNaN(cssSize)) setSize(cssSize);
    }, []);

    const strokeWidth = size * 0.05;
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (percentage / 100) * circumference;

    const { pathname } = useLocation();
    const isResume = pathname === '/resume';
    const isRL = pathname === '/real-life-resume';

    return (
        <svg
            ref={svgRef}
            className={shared.circleSvg}
            viewBox={`0 0 ${size} ${size}`}
        >
            <circle
                className={`${shared.bgCircle} ${isResume ? resume.bgCircle : ''} ${isRL ? rlresume.bgCircle : ''}`}
                cx={size / 2}
                cy={size / 2}
                r={radius}
            />
            <circle
                className={`${shared.fgCircle} ${isResume ? resume.fgCircle : ''} ${isRL ? rlresume.fgCircle : ''}`}
                cx={size / 2}
                cy={size / 2}
                r={radius}
                strokeDasharray={circumference}
                strokeDashoffset={offset}
            />
            <text
                className={`${shared.circleText} ${isResume ? resume.circleText : ''} ${isRL ? rlresume.circleText : ''}`}
                x="50%"
                y="50%"
            >
                {percentage}
            </text>
        </svg>
    );
}

export default CircleProgress;